export default {
    methods: {
        insertSvg(svgText){
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = svgText;
            let svgObject = tempDiv.firstChild;
            this.$refs.svgContainer.appendChild(svgObject);
        }
    }
}
